import type { EventBusKey } from '@vueuse/core';

export const globalKey: EventBusKey<string> = Symbol('global');

export const UPLOAD_UTILITY_ORDER_OPEN = 'uploadUtilityOrder:open';
export const UPLOAD_UTILITY_ORDER_CLOSE = 'uploadUtilityOrder:close';
export const DATA_TABLE_CLEAR_SELECTED_IDS = 'dataTable:clearSelectedIds';
